import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { alertActions, commonActions, verifyActions, modalActions } from '../../../../store/actions'
import Modal from '../modal/VerfyListModal' // 퍼블리싱 임시 : 증명서 목록팝업
import * as common from '../../../../assets/js/common'
import Loading from '../../../../module/loading/Loading'

const CertificateVerify = (props) => {
  const pdfFileRef = useRef()
  // const [contInfo, setContInfo] = useState({})
  const [pdfInfo, setPdfInfo] = useState({})
  const [toggle, setToggle] = useState({
    isHelp: false,
    isSuccess: false,
    isFail: false,
  })
  const [title, setTitle] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    props.verifyInit()
    props.getCommonCode({ mainCd: ['CRT_DV', 'CRT_SUBMIS_TP'] })

    return () => {
      onInit()
    }
  }, [])

  useEffect(() => {
    if (props.certificateInfo !== null && props.certificateInfo !== undefined) {
      if (props.certificateInfo?.result === 'success') {
        setToggle({
          ...toggle,
          isSuccess: true,
          isFail: false,
        })
      } else {
        setToggle({
          ...toggle,
          isSuccess: false,
          isFail: true,
        })
      }
      setLoading(false)
      window.location.href = '#verifyBtn'
    }
  }, [props.certificateInfo])

  const setContractInfo = (contract) => {
    //console.log(contract)
    //console.log(contract.fileNewList.length)
    if (contract.fileNewList.length === 0) {
      props.error({
        title: '검증 불가',
        message: '해당증명에 첨부된 파일이 없습니다.',
      })
      return
    }
    let fileStr = ''
    for (let idx = 0; idx < contract.fileNewList.length; idx++) {
      console.log(contract.fileNewList[idx].originFileNm)
      fileStr += idx > 0 ? ', ' : '' + contract.fileNewList[idx].originFileNm
    }
    setPdfInfo(null)
    setPdfInfo({
      name: fileStr,
      file: undefined,
      id: '',
      fileGroupId: contract.fileGroupId == undefined ? '0' : contract.fileGroupId,
      crtSeq: contract.crtSeq == undefined ? '0' : contract.crtSeq,
      crtRcvSeq: contract.crtRcvSeq == undefined ? '0' : contract.crtRcvSeq,
    })
  }

  const toggleHelp = () => {
    setToggle({ ...toggle, isHelp: !toggle.isHelp })
  }

  const setFile = (e) => {
    const { files, id } = e.target
    onInitToggle()

    if (files.length < 1) return

    //console.log(files[0].size)
    if (files[0].size > 10485760) {
      props.error({ message: '파일은 10MB 이하로만 가능합니다.' })
      return
    }

    // 기존 선택된 파일이 있으면 초기화 한번 날려줌
    if (pdfInfo.name !== undefined && pdfInfo.name !== null) {
      //onInit();
    }

    setPdfInfo(null)
    setPdfInfo({
      name: files[0].name,
      file: files[0],
      id: id,
      fileGroupId: '',
      crtSeq: '0',
      crtRcvSeq: '0',
    })
  }

  //증명서 검증 버튼 클릭
  const onVerify = () => {
    if (pdfInfo.name === undefined || pdfInfo.name === null) {
      props.error({
        title: '검증 불가',
        message: '검증할 증명서 PDF를 등록하세요.',
      })
      return
    } else {
      setLoading(true)
      props.verifyCertificate(pdfInfo)
    }
  }

  //toggle만 초기화
  const onInitToggle = () => {
    setToggle({
      ...toggle,
      isSuccess: false,
      isFail: false,
    })
  }

  // 증명서 검증 화면 초기화
  const onInit = () => {
    onInitToggle()
    setPdfInfo({})
    // setContInfo({})
    pdfFileRef.current.value = ''
    props.verifyInit()
  }
  // 퍼블리싱 임시: 모달 Open
  const showModalSent = () => {
    // set Title
    setTitle('보낸 증명서')
    onInitToggle()
    let sendSearch = {}
    sendSearch = {
      selectedSubject: 'ALL',
      tabStatus: '12',
      pageSizeCustom: 999,
    }
    props.verifySentListShow(sendSearch)
    props.showModalBagic(true)
  }
  const showModalRcv = () => {
    // set Title
    setTitle('받은 증명서')
    onInitToggle()
    let sendSearch = {}
    sendSearch = {
      selectedSubject: 'ALL',
      tabStatus: '99',
      pageSizeCustom: 999,
      searchWord:'',
    }
    props.verifyInboxListShow(sendSearch)
    props.showModalBagic(true)
  }
  // 퍼블리싱 임시: 모달 Close
  const clearModal = () => {
    props.clearModal()
  }
  return (
    <React.Fragment>
      {loading ? <Loading /> : null}
      <div className="ServiceDashboard">
        {/* <ServiceDashboard /> */}
        {/*dash board */}
      </div>

      <>
        {/* container */}
        <div id="container">
          {/* contents */}
          <div id="contents">
            <div className="content-header">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  window.history.back()
                }}
                className="page-prev"
              >
                뒤로이동
              </a>
              {/* mobile */}
              <h2>증명서진본검증</h2>
              <div className="breadcrumb">
                <span>Home</span>
                <span>전자문서지갑</span>
                <em>증명서진본검증</em>
              </div>
            </div>
            <div className="upload-wrap">
              {common.getDeviceType() !== 'MobileApp' ? (
                <div className="upload-box">
                  <i className="ico ico1" />
                  <dl>
                    <dt>외부파일업로드검증</dt>
                    <dd>로컬에서 pdf 파일을 등록합니다.</dd>
                  </dl>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault()
                      pdfFileRef.current.click()
                    }}
                    className="btn-secondary md"
                  >
                    파일 업로드
                  </a>
                  {/* <input name="verify-method" type="radio" id="methods1" /> */}
                </div>
              ) : (
                ''
              )}

              <div className="upload-box">
                <i className="ico ico2" />
                <dl>
                  <dt>보낸증명서 파일 검증</dt>
                  <dd>보낸문서함의 증명서를 선택합니다.</dd>
                </dl>
                <a href="#" onClick={() => showModalSent()} className="btn-secondary md">
                  파일 선택
                </a>
                {/* <input name="verify-method" type="radio" id="methods2" /> */}
              </div>
              <div className="upload-box">
                <i className="ico ico3" />
                <dl>
                  <dt>받은증명서 파일 검증</dt>
                  <dd>받은문서함의 증명서를 선택합니다.</dd>
                </dl>
                <a href="#" onClick={() => showModalRcv()} className="btn-secondary md">
                  파일 선택
                </a>
                {/* <input name="verify-method" type="radio" id="methods3" /> */}
              </div>
            </div>
            <div className="upload-select">
              {pdfInfo.name ? <p className="file"> {pdfInfo.name} </p> : <p className="txt">증명서 PDF를 선택하세요.</p>}
              {toggle.isSuccess ? (
                <a href="#" onClick={onInit} className="btn-primary lg">
                  초기화
                </a>
              ) : (
                <a href="#" onClick={onVerify} className="btn-primary lg" id="verifyBtn">
                  진본검증
                </a>
              )}
              <input
                title="첨부파일"
                type="file"
                ref={pdfFileRef}
                name="pdfFile"
                id="pdfFile"
                className="upload-hidden"
                accept=".pdf"
                onChange={(e) => {
                  e.preventDefault()
                  setFile(e)
                }}
              />
            </div>
            {toggle.isSuccess && (
              <>
                <div className="result-box">
                  <p className="txt">검증결과 : {props.certificateInfo?.issuenm}에서 발급한 증명서입니다.</p>
                </div>
                <div className="result-guide">
                  <dl>
                    <dt>시점확인</dt>
                    <dd>
                      시점확인 시간 :{' '}
                      {props.certificateInfo?.verifydt &&
                        moment(props.certificateInfo?.verifydt, 'YYYYMMDDhhmmss').format('YYYY/MM/DD HH:mm:ss')}
                    </dd>
                    <dd>시점확인 전자서명 해시 :{props.certificateInfo?.hash}</dd>
                  </dl>
                </div>
                <div className="result-guide">
                  <dl>
                    <dt>발급이력</dt>
                    <dd>
                      증명서 : {props.commoncode?.CRT_DV?.find((co) => co.cd === props.certificateInfo?.crtdv)?.cdName} |{' '}
                      {props.certificateInfo?.crtkey}
                    </dd>
                    <dd>
                      발급 : {props.certificateInfo?.issuenm} |{' '}
                      {moment(props.certificateInfo?.issuedt, 'YYYYMMDDhhmmss').format('YYYY/MM/DD HH:mm:ss')}
                    </dd>
{/*                     <dd>체인ID : {props.certificateInfo?.certid}</dd> */}
                  </dl>
                </div>
              </>
            )}
            {toggle.isFail && (
              <>
                <div className="result-box">
                  <p className="txt" style={{ color: 'red' }}>
                    검증결과 : {props.certificateInfo?.message ? props.certificateInfo?.message : '전자서명값을 확인 할 수 없습니다.'}
                  </p>
                </div>
              </>
            )}
          </div>
          {/* //contents */}
        </div>
        {/* //container */}
      </>

      <Modal setContractInfo={setContractInfo} title={title} />
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    commoncode: state.commoncode?.co,
    certificateInfo: state.verify?.certificateInfo,
    isFailure: state.verify?.isFailure,
  }
}

const actionCreators = {
  getCommonCode: commonActions.getCommonCode,
  verifyInit: verifyActions.verifyInit,
  verifyCertificate: verifyActions.verifyCertificate,
  verifyInboxListShow: verifyActions.verifyInboxListShow,
  verifySentListShow: verifyActions.verifySentListShow,
  error: alertActions.error,
  showModalBagic: modalActions.showModalBagic,
  clearModal: modalActions.clearModal,
}

export default connect(mapStateToProps, actionCreators)(CertificateVerify)
